import React from 'react';
import ContactForm from '../components/ContactForm';
import './Support.css';

const Support: React.FC = () => {
  return (
    <div className="support-page">
      <div className="support-container">
        <div className="support-header">
          <h1 className="support-title">Support</h1>
          <p className="support-subtitle">
            Have a question or need help? We're here to assist you.
          </p>
        </div>

        <ContactForm showWhatsApp={true} />
      </div>
    </div>
  );
};

export default Support;
